export default defineNuxtRouteMiddleware(async (to, from) => {
  // set feature flag rules here
})
